import React from 'react';
import Iframe from 'react-iframe';

const Map = () => {
    return (
        <div style={{ width: '100%' ,height:'100px' }}>
            <Iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=cox's%20bazar%20hotel+(Travel%20Guru)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></Iframe>
        </div>
    );
};

export default Map;